module.exports = {
  "country": "CZ",
  "artist": "Gabriela Gunciková ",
  "song": "I Stand",
  "year": "2016",
  "place": "25",
  "spotify": "1rjlAtGiXwrJE8Tpj4lZ40"
};